export default "__VITE_ASSET__BdQaL8Py__"